// extracted by mini-css-extract-plugin
export default {"filter-input":"Input_filter-input__BQ12g"};